// Draws a branded PhonePlay result card on a canvas and shares/downloads it.
import { toast } from "sonner";

export async function shareWinCard({ score, subtitle = "", accent = "#34d399", game = "WORDVOLT", unit = "POINTS", name = "WordVolt", caption: customCaption }) {
  const S = 1080;
  const canvas = document.createElement("canvas");
  canvas.width = S; canvas.height = S;
  const ctx = canvas.getContext("2d");

  // background
  ctx.fillStyle = "#0a0d14";
  ctx.fillRect(0, 0, S, S);
  const glow = ctx.createRadialGradient(S / 2, S * 0.42, 60, S / 2, S * 0.42, S * 0.7);
  glow.addColorStop(0, accent + "33");
  glow.addColorStop(1, "#0a0d1400");
  ctx.fillStyle = glow;
  ctx.fillRect(0, 0, S, S);

  // border
  ctx.strokeStyle = accent + "66";
  ctx.lineWidth = 6;
  ctx.strokeRect(40, 40, S - 80, S - 80);

  ctx.textAlign = "center";

  // wordmark
  ctx.font = "700 62px Georgia, serif";
  const px = S / 2, wy = 170;
  ctx.fillStyle = "#ffffff";
  const a = "Phone", b = "Play";
  const aw = ctx.measureText(a).width, bw = ctx.measureText(b).width;
  ctx.textAlign = "left";
  ctx.fillText(a, px - (aw + bw) / 2, wy);
  ctx.fillStyle = "#a78bfa";
  ctx.fillText(b, px - (aw + bw) / 2 + aw, wy);
  ctx.textAlign = "center";

  // game label
  ctx.fillStyle = accent;
  ctx.font = "700 44px Georgia, serif";
  ctx.fillText(game, px, 300);

  // score
  ctx.fillStyle = "#ffffff";
  ctx.font = "800 320px Georgia, serif";
  ctx.fillText(String(score), px, 640);
  ctx.fillStyle = "#9ca3af";
  ctx.font = "600 46px Georgia, serif";
  ctx.fillText(unit, px, 710);

  // subtitle
  if (subtitle) {
    ctx.fillStyle = accent;
    ctx.font = "600 48px Georgia, serif";
    ctx.fillText(subtitle, px, 830);
  }

  // tagline
  ctx.fillStyle = "#6b7280";
  ctx.font = "500 40px Georgia, serif";
  ctx.fillText("Where Skill Wins  ·  phoneplay.net", px, 980);

  const blob = await new Promise((res) => canvas.toBlob(res, "image/png"));
  const caption = customCaption || `I scored ${score} on ${name}${subtitle ? " — " + subtitle : ""}! Beat me on PhonePlay 🎯 phoneplay.net`;
  const file = new File([blob], `phoneplay-${name.toLowerCase()}.png`, { type: "image/png" });

  try {
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({ files: [file], text: caption, title: `PhonePlay ${name}` });
      return;
    }
  } catch { /* user cancelled or unsupported — fall through to download */ }

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url; link.download = `phoneplay-${name.toLowerCase()}.png`;
  link.click();
  URL.revokeObjectURL(url);
  try { await navigator.clipboard.writeText(caption); } catch { /* ignore */ }
  toast.success("Card saved! Caption copied — share it anywhere.");
}
